import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { type ClientSessionDto, getClientsForLoggedInUser } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useSessions(): UseQueryResult<ClientSessionDto[], AxiosError> {
    const queryKey = useMemo(() => queryKeys.sessions(), []);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getClientsForLoggedInUser({ signal }).then((result) => result.data!),
    });
}
